import {css} from 'lit';
export const styles = css`:host {
  --app-primary-color: #01965f;
  --app-primary-color-400: #017243;

  --app-secondary-color: black;

  --accent-color: var(--google-red-500);
  --accent-color-400: var(--google-red-300);

  --accent-home: var(--google-red-500);
  --accent-home-400: var(--google-red-300);
  --accent-away: var(--google-green-500);
  --accent-away-400: var(--google-green-300);
}

@media (min-width: 1021px) {
    [drawer-toggle] {
        display: none;
    }
}

[role="content"] {
    max-width: 800px;
    margin: auto;
}

[main-title] {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

iron-image {
    border: 1px solid white;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    cursor: pointer;
}

mwc-menu iron-icon {
    color: black;
}`;
export default styles;
